<template>
  <div id="favComponent">
    <Header @onChangeSetting="onChangeSetting" @onChangLogin="onChangLogin" :setShow="['timeZone', 'oddsForm']" :tsz="svrTimestamp" :isLogin="loginShow" :myLeague="myLeague" :hotLeague="hotLeague" :navTab="true" />
    <NavBar :tab="1" :favLiveNum="favLiveNum" @onChangLogin="onChangLogin" :isLogin="loginShow" />
    <div class="page-content flex flex-pack-justify">
      <div class="page-left">
        <MyLeague :myLeague="myLeague" />
        <HotLeague :hotLeague="hotLeague" :myLeague="myLeague" />
        <div class="all-item-box flex flex-align-center">
          <i class="all-icon-fan icon-font icon-fan"></i>
          <router-link to="/leagues/0/0" class="flex flex-align-center">
            <span class="all-item-text">{{ langConfig.txtLang[langConfig.curLang]['ALL_LEAUGES'] }}</span>
            <i class="all-arr-right icon-font icon-arr"></i>
          </router-link>
        </div>
      </div>
      <div class="page-center">
        <div class="container-livetable">
          <div class="filters-wrapper flex">
            <div class="filter-group filter-group-fav">
              <div class="filter-tab filter-tab-fav flex flex-align-center">
                <template v-for="(item, index) in langConfig.favorites[langConfig.curLang]['FILTER_TAB']">
                <span :class="tabId==item.id ? 'selected' : ''" :key="index" @click="tabChange(item.id)"><b>{{ item.name }}<i class="icon-badge" v-if="item.id==2&&favLiveNum>0">{{favLiveNum}}</i></b></span>
                </template>
                <i class="icon-font icon-set icon-company-set" style="margin-left:auto;" ref="setCompany2" @click="setCompany()"></i>
              </div>
            </div>

            <div class="company-btn-box">
              <span class="company-btn" ref="setCompany" @click="setCompany()">{{ companyName() }}</span>
              <div class="company-btn-pop" :class="popCompany ? 'company-btn-pop-show' : ''" ref="popSetCompany" @click.self="companyBodyClose()">
                <i class="icon-font icon-close icon-company-close" @click="setCompany()"></i>
                <div class="setting-menu-contant flex flex-v">
                  <div class="setting-mode flex flex-v">
                    <div class="setting-mode-title flex flex-align-center">
                      <i class="icon-font icon-type"></i>
                      <span class="mode-text">{{ langConfig.setting[langConfig.curLang]['ODDS_TYPES'] }}</span>
                    </div>
                    <div class="setting-mode-content">
                      <div class="setting-odds-type flex flex-pack-justify">
                        <span :class="liveDatas.oddsTypeArr.includes(item.id) ? 'sot-is-checked' : ''" v-for="(item, index) in oddTypeArr" @click="onSetOddsType(item.id, 1)" :key="index">{{ item.name }}</span>
                      </div>
                      <div class="setting-odds-type-mobli flex flex-pack-justify">
                        <span :class="liveDatas.oddsType*1 == item.id ? 'sot-is-checked' : ''" v-for="(item, index) in langConfig.index[langConfig.curLang]['ODDS_TYPE_TAB']" @click="onSetOddsType(item.id, 2)" :key="index">{{ item.name }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="setting-mode flex flex-v">
                    <div class="setting-mode-title flex flex-align-center">
                      <i class="icon-font icon-type"></i>
                      <span class="mode-text">{{ langConfig.details[langConfig.curLang]['ODDS']['BOOKMAKERS'] }}</span>
                    </div>
                    <div class="setting-mode-content">
                      <div class="setting-odds-company">
                        <span :data-id="item.id" :class="item.id*1 == companyId*1 ? 'sot-is-checked' : ''" v-for="(item, index) in companys" @click="onChangeCompany(item.id)" :key="index">{{ item.name }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="company-btn-pop-mask" v-show="popCompany"></div>
            </div>
          </div>
          <div class="live-table-wrapper">
            <FavritesList :liveData="liveDatas" ref="soccerListFn" @rechangList="rechangList" />
          </div>
        </div>
      </div>
      <div class="page-right">
        <template v-if="ListAd.length>0">
          <template v-for="(item, index) in ListAd">
            <div class="ad-box" :class="item.flag ? '' : 'ad-no-icon'" v-if="item.siteId == 201" :key="index">
              <router-link :to="'/gdt?gdtUrl=' + item.url" target="_blank" @click.native="adHit(item.id)"><img :src="item.img" /></router-link>
            </div>
          </template>
        </template>
        <template v-if="ListAd.length>0">
          <template v-for="(item, index) in ListAd">
            <div class="ad-box ad-sticky" :class="item.flag ? '' : 'ad-no-icon'" v-if="item.siteId == 202" :key="index">
              <router-link :to="'/gdt?gdtUrl=' + item.url" target="_blank" @click.native="adHit(item.id)"><img :src="item.img" /></router-link>
            </div>
          </template>
        </template>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
  import { mapState, mapMutations, mapActions } from 'vuex';

  import { getDataList, getSocket, getSocketUpdate, getFavoritesList, getListAd, getAdHits, getLeagueListHot, getListFollowIds, getLeagueListFollow, getMatchLuckCompany, getListFollowLuck, getListFollowLuckDiff } from '@/api/api';

  import Header from '@/components/header.vue';
  import NavBar from '@/components/navbar.vue';
  import Footer from '@/components/footer.vue';
  import MyLeague from '@/components/myLeague.vue';
  import HotLeague from '@/components/hotLeague.vue';
  import FavritesList from './components/favritesList.vue';

	export default {
    name: 'index',
    components: {
      Header,
      NavBar,
      Footer,
      MyLeague,
      HotLeague,
      FavritesList
    },
    
    props: {},

    // asyncData ( { store, route } ) {
    //     return  store.dispatch('home/fetchDataList', {
    //         isLive: 1,
    //         matchDate: '2024-01-14',
    //         timeZone: 8,
    //         userToken: '',
    //         langNumber: 3,
    //         platform: 4,
    //         portType: 1
    //       })

    //     // return Promise.all([
    //     //   this.getMvUrl(store, route),
    //     //   this.getMvLikedCount(store, route),
    //     //   this.getMvDetail(store, route).then(async () => {
    //     //     await this.getArtistDetail(store, route);
    //     //     await this.getArtistMvList(store, route);
    //     //     await store.dispatch("HistoryMv/addHistoryMv", store.state.WatchMv.mv);
    //     //   }),
    //     //   this.getCommentMvList(store, route),
    //     // ]).then();
    // },

		data(){
			return{
        liveParam: { // 比分列表请求参数
          timeZone: '+08:00',
          userToken: '',
        },
        setting:{
          darkSwith: false,
          soundSwith: true,
          sortRadio: '1',
          oddsType: 1,
          oddsFormRadio: '1',
          tsz: '+08:00'
        },
        svrTimestamp: 0,

        liveSate: [1,2,3,5,10,11,16], //比赛进行中
        oddsArr: ['threeWayLuckMatch', 'asianLuckMatch', 'totalLuckMatch'], //指数类型
        sortType: 2, // 排序类型
        tabId: 0, // tab切换
        oddsType: 2, // 赔率类型
        oddsForm: 1, // 赔率格式
        showState:'state_0', // 列表状态

        FootballListObj: {}, // 源数据
        FootballList: {}, // 源数据
        FootballSortMatch: {}, // 排序后的数据
        LeagueList: {}, // 渲染数据
        FootballMatch: {},
        isExpanded: [],
        disMatch: [],// 赛事隐藏

        oddsData:{
          'odds_1': {},
          'odds_2': {},
          'odds_3': {},
        }, // 指数类型列表数据
        dynState: {}, // 动态更新标识
        follow: {},
        favNum: 0, //关注数
        favLiveNum:0, //关注进行中数量

        version: 0, // 数据版本号
        ListAd: [], // 广告

        liveDatas: {
          tabId: 0,
          oddsType: 2,
          oddsTypeArr:[2,3], // 赔率类型数组
          oddsForm: 1,
          FootballList: {},
          svrTimestamp: 0,
          LeagueList: [],
          oddsData:{
            'odds_1': {},
            'odds_2': {},
            'odds_3': {},
          },
          isExpanded: [],
          disMatch: [],// 赛事隐藏
          FootballMatch: {},
          dynState: {},
          tsz: '+08:00',
          follow: {},
          myLeague: [],
          oddsDateDiff:{ //指数新旧存储
            odds_1:{},
            odds_2:{},
            odds_3:{},
          },
        },

        hotLeague: [],
        myLeague: [],
        loginShow: false, // 是否显示登录弹窗
        
        processTimeFlag: true, // 进程时间标识

        companyData: {}, // 公司数据
        companys: [], // 公司
        companyId: '3000181', // 选中公司id
        oddTypeArr: [
          {
            id:2,
            name:'AH'
          },
          {
            id:3,
            name:'O/U'
          },
          {
            id:1,
            name:'1x2'
          },
        ],
        popCompany: false, // 公司选择弹窗标识
			}
		},

    computed: {
      //...mapState('home', ['FootballList']),
      // dataList () {
      //     return this.$store.state.home.dataList;
      // }
      // ws() {
      //   return socketServer.Instance
      // }
    },

    mounted(){
      let _isLoginPm = this.common.isLogin(); // 是否登录Promise
      _isLoginPm.then((res)=>{ // res返回true,false
        let _isLogin = res;
        console.log('是否登录',_isLogin)

        if(!_isLogin){// 未登录
          this.$router.push('/')
        }
      })

      if(typeof(window) != 'undefined'){
        document.addEventListener('click', this.companyBodyClose);
      }
    },

		methods:{
      //...mapMutations('home', ['setFootballList']),

      //修改控件今天时间 
      setTodays(){
        //let _svrTimestamp = this.common.jsonParse(this.svrTimestamp);
        //this.svrTimestamp = _svrTimestamp;
        //this.liveDatas.svrTimestamp = _svrTimestamp;

        if(typeof(window) != 'undefined' && this.processTimeFlag){
          this.processTimeFlag = false;
          setTimeout(()=>{
            this.$refs.soccerListFn.timeDiff();
          },10)
          this.$refs.soccerListFn.process_time();
        }
      },

      tabChange(id){ // 切换tab
        if(this.common.jsonParse(this.tabId) == id){
          return;
        }
        this.tabId = id;
        this.liveDatas.tabId = id;

        this.showState = 'state_0';

        let _showState = this.common.jsonParse(this.showState);
        this.liveDatas.isExpanded = this.common.jsonParse(this.isExpanded[_showState]);
        this.liveDatas.disMatch = this.common.jsonParse(this.disMatch[_showState]);
        this.liveDatas.LeagueList = this.common.jsonParse(this.LeagueList[_showState]);

        //this.setTime();
      },

      // tab隐藏
      tabHide(id){
        let _today = this.common.jsonParse(this.todayDate), _currentDate = this.common.jsonParse(this.currentDate);
        if(id == 3){
          if(_currentDate > _today){
            return false;
          }else{
            return true;
          }
        }

        if(id == 4){
          if(_currentDate < _today){
            return false;
          }else{
            return true;
          }
        }
        return true;
      },

      // 联赛排序
      sortItemsByLeagueKeys(_dataTemp) {
        //console.log('联赛排序')
        ////console.log(JSON.stringify(_dataTemp['matchList']))
        let item = [], _arr1 = [], _filterArr = [0, 1];
        item = _dataTemp['match']
        ////console.log(item)
        // 按ID降序
        item.sort((a, b) => a.matchId < b.matchId ? 1 : -1);
        // 按时间升序
        item.sort((a, b) => a.startTime < b.startTime ? 1 : -1);
        // a~z 联赛排序
        item.sort((a, b) => _dataTemp['league'][a.leagueId]['fullName'] > _dataTemp['league'][b.leagueId]['fullName'] ? 1 : -1);

        // 联赛等级排序
        for(let t=(_filterArr.length-1); t>=0; t--){
            for(let s=(item.length-1); s>=0; s--){
                if(typeof(_dataTemp['league'][item[s]['leagueId']]['grade']) == 'undefined'){
                  _dataTemp['league'][item[s]['leagueId']]['grade'] = 0;
                }
                if(_dataTemp['league'][item[s]['leagueId']]['grade'] == _filterArr[t]){
                  let ceshi = item[s];
                    ////console.log(s + '|||' + JSON.stringify(ceshi))
                    item.splice(s,1);
                    _arr1.unshift(ceshi);
                }
            }
        }

        item = _arr1.concat(item);
        _dataTemp['match'] = item;
        ////console.log(JSON.stringify(_dataTemp))
        this.FootballSortMatch = _dataTemp
        //this.matchDataCollation();
        this.leagueIdCollation();
      },

      // 时间排序
      sortItemsByTimeKeys(_dataTemp){
        let item = [];
        item = _dataTemp['match']
        // if(item.length == 0){
        //   return;
        // }
        // if(item.length > 0){
        //   // 排序
        //   item.sort(function (a, b) {
        //       if (a.startTime == b.startTime) { // 时间相同时按id降序
        //           return a.matchId < b.matchId ? -1 : 1;
        //       } else { // 按时间从小到大排序
        //           return a.startTime - b.startTime;
        //       }
        //   });
        // }

        _dataTemp['match'] = item;
        this.FootballSortMatch = _dataTemp;
        //this.matchDataCollation();
        this.leagueIdCollation();
      },

      // 联赛数据整理
      leagueIdCollation(){
        let _data = this.common.jsonParse(this.FootballSortMatch), _companyData = this.companyData, _matchList = [], _oddsArr = this.common.jsonParse(this.oddsArr), _oddsData=this.common.jsonParse(this.liveDatas.oddsData), _matchData={}, _dynState = {}, _footballList = this.common.jsonParse(this.FootballList);
        var that = this;

        if(typeof(_data['match']) != 'undefined'){
          _matchList = _data['match'];
        }

        // 比赛数据包整理
        _matchList.forEach((item, index) => {
          _matchData[item.matchId] = item;
          
          _dynState[item.matchId] = { // 比分更新动态标识
            'homeLive': {
              'scoreFull': false,
            },
            'awayLive': {
              'scoreFull': false,
            },
            'odds_1': {
              'home': 0, // 0-不变, 1-升, 2-降
              'draw': 0,
              'away': 0
            },
            'odds_2': {
              'home': 0,
              'hand': 0,
              'away': 0
            },
            'odds_3': {
              'over': 0,
              'total': 0,
              'under': 0
            }
          };
        })
        this.liveDatas.FootballMatch = _matchData;
        this.dynState = _dynState;
        
        // 列表数据整理
        var state_1=[1,2,3,5,10,11,16],
            state_2_0=[],
            state_2_1=[],
            state_2_2=[],
            state_2_3=[],
            state_3=[4],
            state_4=[17];
        var listAll={
            state_0:[],
            //state_1:[],
            state_2_0:[],
            state_2_1:[],
            state_2_2:[],
            state_2_3:[],
            //state_3:[],
            //state_4:[],
        }
        var _isExpanded={
            state_0:[],
            //state_1:[],
            state_2_0:[],
            state_2_1:[],
            state_2_2:[],
            state_2_3:[],
            //state_3:[],
            //state_4:[],
        }
        var _disMatch={
            state_0:[],
            //state_1:[],
            state_2_0:[],
            state_2_1:[],
            state_2_2:[],
            state_2_3:[],
            //state_3:[],
            //state_4:[],
        }

        // 指数整理
        for(let i=0; i<_oddsArr.length; i++){
          for(let id in _companyData[_oddsArr[i]]){
            if(!state_2_0.includes(id*1)){
              state_2_0.push(id*1)
            }
            // if(i == 0){
            //   state_2_1.push(id*1);
            // }
            // if(i == 1){
            //   state_2_2.push(id*1);
            // }
            // if(i == 2){
            //   state_2_3.push(id*1);
            // }
            // _oddsData['odds_'+(i+1)] = _companyData[_oddsArr[i]];
          }
        }
        //this.oddsData = _oddsData;

        // 列表数据整理
        _matchList.forEach((list_i, index) => {
            listAll.state_0.push(list_i);
            // if (state_1.includes(list_i.state*1)) {listAll.state_1.push(list_i);}
            // if (state_3.includes(list_i.state*1)) {listAll.state_3.push(list_i);}
            // if (state_4.includes(list_i.state*1)) {listAll.state_4.push(list_i);}
            if (state_2_0.includes(list_i.matchId*1)) {listAll.state_2_0.push(list_i);}
            // if (state_2_1.includes(list_i.matchId*1)) {listAll.state_2_1.push(list_i);}
            // if (state_2_2.includes(list_i.matchId*1)) {listAll.state_2_2.push(list_i);}
            // if (state_2_3.includes(list_i.matchId*1)) {listAll.state_2_3.push(list_i);}
        });

        //console.log('开始排序', this.sortType)
        // 比赛列表
        if(this.sortType == 1){ // 联赛排序
          listAll.state_0=this.leagueCollationFn(listAll.state_0);
          // listAll.state_1=leagueCollationFn(listAll.state_1);
          // listAll.state_3=leagueCollationFn(listAll.state_3);
          // listAll.state_4=leagueCollationFn(listAll.state_4);
          listAll.state_2_0=this.leagueCollationFn(listAll.state_2_0);
          // listAll.state_2_1=this.leagueCollationFn(listAll.state_2_1);
          // listAll.state_2_2=this.leagueCollationFn(listAll.state_2_2);
          // listAll.state_2_3=this.leagueCollationFn(listAll.state_2_3);
        }else if(this.sortType == 2){ // 时间排序
          listAll.state_0=this.timeCollationFn(listAll.state_0);
          // listAll.state_1=timeCollationFn(listAll.state_1);
          // listAll.state_3=timeCollationFn(listAll.state_3);
          // listAll.state_4=timeCollationFn(listAll.state_4);
          listAll.state_2_0=this.timeCollationFn(listAll.state_2_0);
          // listAll.state_2_1=this.timeCollationFn(listAll.state_2_1);
          // listAll.state_2_2=this.timeCollationFn(listAll.state_2_2);
          // listAll.state_2_3=this.timeCollationFn(listAll.state_2_3);
        }

        // 是否展开数据
        _isExpanded.state_0 = this.defaultExpanded(listAll.state_0);
        // _isExpanded.state_1 = this.defaultExpanded(listAll.state_1);
        // _isExpanded.state_3 = this.defaultExpanded(listAll.state_3);
        // _isExpanded.state_4 = this.defaultExpanded(listAll.state_4);
        _isExpanded.state_2_0 = this.defaultExpanded(listAll.state_2_0);
        // _isExpanded.state_2_1 = this.defaultExpanded(listAll.state_2_1);
        // _isExpanded.state_2_2 = this.defaultExpanded(listAll.state_2_2);
        // _isExpanded.state_2_3 = this.defaultExpanded(listAll.state_2_3);

        // 隐藏比赛数
        _disMatch.state_0 = this.defaultMatchHide(listAll.state_0, _isExpanded.state_0);
        // _disMatch.state_1 = this.defaultMatchHide(listAll.state_1, _isExpanded.state_1);
        // _disMatch.state_3 = this.defaultMatchHide(listAll.state_3, _isExpanded.state_3);
        // _disMatch.state_4 = this.defaultMatchHide(listAll.state_4, _isExpanded.state_4);
        _disMatch.state_2_0 = this.defaultMatchHide(listAll.state_2_0, _isExpanded.state_2_0);
        // _disMatch.state_2_1 = this.defaultMatchHide(listAll.state_2_1, _isExpanded.state_2_1);
        // _disMatch.state_2_2 = this.defaultMatchHide(listAll.state_2_2, _isExpanded.state_2_2);
        // _disMatch.state_2_3 = this.defaultMatchHide(listAll.state_2_1, _isExpanded.state_2_3);
        

        this.isExpanded = _isExpanded;
        this.disMatch = _disMatch;
        this.LeagueList = listAll;

        let _showState = this.common.jsonParse(this.showState);
        let _liveDatas = {};
        _liveDatas.isExpanded = _isExpanded[_showState];
        _liveDatas.disMatch = _disMatch[_showState];
        _liveDatas.LeagueList = this.common.jsonParse(this.LeagueList[_showState]);
        _liveDatas.oddsData = _oddsData;
        _liveDatas.FootballList = this.common.jsonParse(this.FootballList);
        //_liveDatas.FootballMatch = this.common.jsonParse(this.FootballMatch);
        //_liveDatas.oddsType = this.common.jsonParse(this.oddsType);
        _liveDatas.dynState = this.common.jsonParse(this.dynState);
        _liveDatas.svrTimestamp = this.common.jsonParse(this.svrTimestamp);
        _liveDatas.tabId = this.common.jsonParse(this.tabId);
        _liveDatas.tsz = this.common.jsonParse(this.liveParam.timeZone);
        //_liveDatas.oddsForm = this.common.jsonParse(this.oddsForm);
        this.liveDatas = { ...this.liveDatas, ..._liveDatas };
        //console.log(_liveDatas)
        //this.liveDatas = _liveDatas;

        if(typeof(window) != 'undefined'){
          setTimeout(()=>{
            this.$refs.soccerListFn.dateMatchNumFn();
          }, 100)
        }
          
      },

      // 联赛排序整理
      leagueCollationFn(list){
          var obj={};
          var theLeague=[];
          var newlist=[];
          for (let i = 0; i < list.length; i++) {
              let list_i=list[i];
              let leagueID=list_i.leagueId;
              if(theLeague.includes(leagueID)){
                  for(let j=0; j<newlist.length; j++){
                      if(newlist[j]['leagueId'] == list_i.leagueId){
                          newlist[j]['matches'].push(list_i.matchId);
                      }
                  }
              }else{
                  theLeague.push(leagueID);
                  obj={
                      'leagueId':leagueID,
                      'matches':[]
                  } 
                  obj['matches'].push(list_i.matchId);
                  newlist.push(obj);
              }
          }
          return newlist
      },
      
      // 时间排序整理
      timeCollationFn(list){
          var obj={};
          var theLeague=0;
          var newlist=[];
          for (let i = 0; i < list.length; i++) {
              let list_i=list[i];
              let leagueID=list_i.leagueId;
              if(theLeague==list_i.leagueId){
                obj['matches'].push(list_i.matchId);
                if((list.length-1) == i){
                  newlist.push(obj);
                }
              }else{
                if(i!=0){
                    newlist.push(obj);
                    obj={};
                }
                theLeague=leagueID;
                obj={
                    'leagueId':leagueID,
                    'matches':[]
                } 
                obj['matches'].push(list_i.matchId);
                if((list.length-1) == i){
                  newlist.push(obj);
                }
              } 
          }
          return newlist
      },

      // 指数数据整理
      oddsCollation(){
        let _data = this.common.jsonParse(this.FootballSortMatch), _matchList = [], _companyData = this.companyData, _oddsArr = this.oddsArr, _oddsData={};

        if(typeof(_data['match']) != 'undefined'){
          _matchList = _data['match'];
        }

        var state_2_0=[];
        var listAll={
            state_2_0:[]
        }
        var _isExpanded={
            state_2_0:[],
        }
        var _disMatch={
            state_2_0:[],
        }

        // 指数整理
        for(let i=0; i<_oddsArr.length; i++){
          for(let id in _companyData[_oddsArr[i]]){
            if(!state_2_0.includes(id*1)){
              state_2_0.push(id*1)
            }
            // if(i == 0){
            //   state_2_1.push(id*1);
            // }
            // if(i == 1){
            //   state_2_2.push(id*1);
            // }
            // if(i == 2){
            //   state_2_3.push(id*1);
            // }
            _oddsData['odds_'+(i+1)] = _companyData[_oddsArr[i]];
          }
        }

        // 列表数据整理
        _matchList.forEach((list_i, index) => {
          this.liveDatas.dynState[list_i.matchId] = { // 指数更新动态标识
            'homeLive': {
              'scoreFull': false,
            },
            'awayLive': {
              'scoreFull': false,
            },
            'odds_1': {
              'home': 0, // 0-不变, 1-升, 2-降
              'draw': 0,
              'away': 0
            },
            'odds_2': {
              'home': 0,
              'hand': 0,
              'away': 0
            },
            'odds_3': {
              'over': 0,
              'total': 0,
              'under': 0
            }
          }

            if (state_2_0.includes(list_i.matchId*1)) {listAll.state_2_0.push(list_i);}
        });

        // 指数列表
        if(this.sortType == 1){ // 联赛排序
          listAll.state_2_0=this.leagueCollationFn(listAll.state_2_0);
        }else if(this.sortType == 2){ // 时间排序
          listAll.state_2_0=this.timeCollationFn(listAll.state_2_0);
        }

        // 是否展开数据
        _isExpanded.state_2_0 = this.defaultExpanded(listAll.state_2_0);

        // 隐藏比赛数
        _disMatch.state_2_0 = this.defaultMatchHide(listAll.state_2_0, _isExpanded.state_2_0);

        this.isExpanded.state_2_0 = _isExpanded.state_2_0;
        this.disMatch.state_2_0 = _disMatch.state_2_0;
        this.LeagueList.state_2_0 = listAll.state_2_0;
        //this.liveDatas.LeagueList = listAll.state_2_0;
        this.liveDatas.isExpanded.state_2_0 = _isExpanded.state_2_0;
        this.liveDatas.disMatch.state_2_0 = _disMatch.state_2_0;
        
       
        //this.oddsData = { ...this.oddsData, ..._oddsData };
        this.liveDatas.oddsData = { ...this.oddsData, ..._oddsData };
      },

      // 默认联赛展开隐藏
      defaultExpanded(data){
        let _matchList = data, _dataTemp = [];
        
        for(let i=0; i<_matchList.length; i++){
          let _li = _matchList[i];
          let _leagueId = _li['leagueId'];

          _dataTemp[i] = {
            'leagueId': _leagueId,
            'isExpanded': true
          }
        }

        return _dataTemp;
      },

      // 默认联赛隐藏比赛数
      defaultMatchHide(data){
        let _matchList=data, _dataTemp = [];

        for(let i=0; i<_matchList.length; i++){
          let _li = _matchList[i];
          let _leagueId = _li['leagueId'];
          let _list = _li['matches'];

          _dataTemp[i] = {
            'leagueId': _leagueId,
            'live': 0,
            'totle': 0
          }

          if(_list.length > 0){
            _dataTemp[i]['totle'] = _list.length;
          }
        }

        return _dataTemp;
      },

      // 关注赛事、热门赛事
      leagueCollation(){
        let _data = this.common.jsonParse(this.FootballListObj), _hotLeague = [], _myLeague = [], _follow = {};

        if(typeof(_data['myLeague']) != 'undefined'){
          _myLeague = _data['myLeague'];
        }
        if(typeof(_data['hotLeague']) != 'undefined'){
          _hotLeague = _data['hotLeague'];
        }

        if(typeof(_data['follow']) != 'undefined'){
          _follow = _data['follow'];
        }

        this.myLeague = _myLeague;
        this.hotLeague = _hotLeague;
        this.follow = _follow;
        this.liveDatas.myLeague = this.myLeague;
        this.liveDatas.follow = this.common.jsonParse(this.follow);
        this.favNum = Object.keys(_follow).length;
        
      },

      // 设置回调参数操作
      onChangeSetting(e){
        let _setting = e;
        let _oddsForm = this.common.jsonParse(this.liveDatas.oddsForm)*1;
        let _tsz = this.common.jsonParse(this.liveParam)['timeZone'];

        if(_oddsForm != _setting.oddsFormRadio*1){ //赔率格式
          //this.oddsForm = _setting.oddsFormRadio*1;
          this.liveDatas.oddsForm = _setting.oddsFormRadio*1;
        }

        if(_tsz != _setting.tsz){ //时区
          this.liveParam['timeZone'] = _setting.tsz;
          this.liveDatas.tsz = _setting.tsz;
        }
      },

      // 登录弹窗回调
      onChangLogin(val){
        let _val = val;
        this.loginShow = _val;
      },

      // 比分回调参数操作
      rechangList(val, type){
        //console.log("更新时间戳", val)
        let _val = val;
        this.svrTimestamp = _val.svrTimestamp;

        if(_val.loginShow){
          this.loginShow = true;
        }else{
          this.loginShow = false;
        }

        if(type == 'follow'){
          this.favNum = Object.keys(_val).length;
        }

        if(type == 'favLive'){
          this.favLiveNum = _val;
        }

        // if(type == 'LeagueList'){
        //   this.LeagueList[this.showState] = _val;
        //   console.log("更新后：", this.LeagueList[this.showState])
        //   this.liveDatas.LeagueList = this.common.jsonParse(this.LeagueList[this.showState] || []);
        // }
      },

      // 列表更新
      listUpdate(data){
        console.log("比分更新数据", data)
        let _matchDate = this.common.jsonParse(this.liveDatas.FootballMatch);
        let _data = JSON.parse(JSON.stringify(getSocketUpdate(data, 'FootballListUpdate')));
        let _version = _data['version'];
        let _state=this.liveSate;
        this.version = _version;
        console.log("解析后：", JSON.stringify(_data))

        // 更新比赛
        let _updateMatch = _data['updateMatch'];

        if(typeof(_updateMatch) != 'undefined' && _updateMatch.length > 0){
          let _upData = {};
          _updateMatch.forEach((item, index) => {  
            if(_state.includes(item.state)){
              if(typeof(item.homeLive.scoreFull) == 'undefined'){
                item.homeLive.scoreFull = 0;
              }

              if(typeof(item.awayLive.scoreFull) == 'undefined'){
                item.awayLive.scoreFull = 0;
              }
            }
            
            _upData[item.matchId] = item;
            this.$refs.soccerListFn.scoreUpdate(_matchDate[item.matchId], item);
          })

          let _newMatchData = this.common.mergeObjects(_matchDate, _upData);
          this.liveDatas.FootballMatch = _newMatchData;
          //this.FootballMatch = _newMatchData;
        }
      },

      // 指数更新
      oddsUpdate(data){
        console.log("指数更新数据", data)
        let _data = this.common.jsonParse(getSocketUpdate(data, 'FootballListLuckUpdate'));
        let _version = _data['version'];
        this.version = _version;

        console.log("指数更新数据解析后：", JSON.stringify(_data))

        let _oddsArr = this.common.jsonParse(this.oddsArr);
        let _oddsData = this.common.jsonParse(this.liveDatas.oddsData);

        // 更新指数
        let _upData = {
          'odds_1': {},
          'odds_2': {},
          'odds_3': {}
        };

        for(let key in _data ){ // 更新类型
          if(Object.keys(_data[key]).length > 0){
            let _item = _data[key];
            for(let gameId in _item){
              let _ol = _item[gameId];
              for(let i=0; i<_oddsArr.length; i++){// 指数类型
                let _odds = _oddsData['odds_'+(i+1)][gameId];
                if(_oddsArr[i] == key && typeof(_odds) != 'undefined'){
                  _upData['odds_'+(i+1)][gameId] = _ol; // 更新数据
                  this.$refs.soccerListFn.oddsUpdate((i+1), gameId, _oddsData['odds_'+(i+1)][gameId], _ol);
                }
              }
            }
          }
        }

        let _newOddsData = this.common.mergeObjects(_oddsData, _upData);
        this.liveDatas.oddsData = _newOddsData;

      },

      // 第一次指数变化
      oddsFirstUpdate(data){
        let _data = data; // 新数据
        let _oddsArr = this.oddsArr;
        let _oddsData = this.common.jsonParse(this.liveDatas.oddsData); // 当前数据
        let _type = [];
        //this.liveDatas.dynState = {};

        for(let key in _data ){ // 更新类型
          if(key == 'threeWayLuckMatch'){ //欧指
            _type[0] = 'home';
            _type[1] = 'away';
            _type[2] = 'draw';
          }

          if(key == 'asianLuckMatch'){ //亚指
            _type[0] = 'home';
            _type[1] = 'away';
            _type[2] = 'hand';
          }

          if(key == 'totalLuckMatch'){ //大小/总分
            _type[0] = 'over';
            _type[1] = 'under';
            _type[2] = 'total';
          }
          if(Object.keys(_data[key]).length > 0){
            let _item = _data[key];
            for(let gameId in _item){
              let _ol = _item[gameId];
              for(let i=0; i<_oddsArr.length; i++){// 指数类型
                let _odds = _oddsData['odds_'+(i+1)][gameId];
                if(_oddsArr[i] == key && typeof(_odds) != 'undefined' && typeof(this.liveDatas.dynState[gameId]) != 'undefined'){
                  //_upData['odds_'+(i+1)][gameId] = _ol; // 更新数据
                  let _newData = _odds;
                  let _oldData = _ol;
                  for(let t=0; t<_type.length; t++){
                    //指数新旧存储
                    let _oddsDataDiff = this.liveDatas.oddsDateDiff;
                    if(typeof(_oddsDataDiff['odds_'+(i+1)][gameId]) == 'undefined'){
                      _oddsDataDiff['odds_'+(i+1)][gameId] = {};
                    }
                    if(typeof(_oddsDataDiff['odds_'+(i+1)][gameId][_type[t]]) == 'undefined'){
                      _oddsDataDiff['odds_'+(i+1)][gameId][_type[t]] = {};
                    }
                    _oddsDataDiff['odds_'+(i+1)][gameId][_type[t]]['old'] = _oldData[_type[t]];
                    _oddsDataDiff['odds_'+(i+1)][gameId][_type[t]]['new'] = _newData[_type[t]];

                    
                    this.liveDatas.oddsDateDiff = _oddsDataDiff;

                    if(_newData[_type[t]] > _oldData[_type[t]]){
                      this.liveDatas.dynState[gameId]['odds_'+(i+1)][_type[t]] = 1;
                    }else if(_newData[_type[t]] < _oldData[_type[t]]){
                      this.liveDatas.dynState[gameId]['odds_'+(i+1)][_type[t]] = 2;
                    }else{
                      this.liveDatas.dynState[gameId]['odds_'+(i+1)][_type[t]] = 0;
                    }
                  }
                }
              }
            }
          }
        }
      },

      // 广告点击
      adHit(id){
        let _id = id;
        let _param = {
          id: _id
        }
        getAdHits(_param);
      },

      // 指数类型选择 type-类型, plat-平台
      onSetOddsType(type, plat){
        let _type = type, _plat = plat, _index = this.liveDatas.oddsTypeArr.indexOf(_type);

        if(_plat == 1){ // PC
          if(_index == -1){
            this.liveDatas.oddsTypeArr.push(_type);
          }else{
            this.liveDatas.oddsTypeArr.splice(_index, 1);
          }
          this.common.setCookie('oddsTypeArr', JSON.stringify(this.liveDatas.oddsTypeArr));
        }else if(_plat == 2){
          //this.oddsType = _type;
          this.liveDatas.oddsType = _type;

          this.common.setCookie('oddsType', this.liveDatas.oddsType);
        }
      },

      // 公司名
      companyName(){
        let _companys = this.companys, _id = this.companyId, _companyName = '';

        if(_companys.length > 0){
          for(let i=0; i<_companys.length; i++){
            if(_companys[i].id == _id){
              _companyName = _companys[i].name;
            }
          }
        }

        return _companyName;
      },

      // 公司设置
      setCompany(){
        this.popCompany = !this.popCompany;
      },

      // 选中公司
      onChangeCompany(id){
        let _id = id;

        if(_id != this.companyId){
          this.companyId = _id;
          this.common.setCookie('companyId', _id);

          let param = {};
          let _userInfo = this.common.getCookie('userInfo');
				
          if(typeof(_userInfo) != 'undefined' && _userInfo != null){
            _userInfo = JSON.parse(_userInfo);
            param.userToken = _userInfo.token;
          }

          this.getListFollowLuck(param);
          // this.getLiveData({
          //   matchDate: _currentDate,
          //   timeZone: _tsz
          // }, 'live')
        }
      },

      // 公司非点击区域隐藏
      companyBodyClose(e) {
        if (this.$refs.setCompany && !this.$refs.setCompany.contains(e.target) && this.$refs.setCompany2 && !this.$refs.setCompany2.contains(e.target) && this.$refs.popSetCompany && !this.$refs.popSetCompany.contains(e.target)) {
          if (this.popCompany){
            this.popCompany = false;
          }
        }
      },

      async getLiveData(obj, liveType) {
          let param = Object.assign(obj, this.liveParam);
          let _version = 0;

          let favParam = {
            userToken: '',
          }
          
          let _userInfo = this.common.getCookie('userInfo');
				
          if(typeof(_userInfo) != 'undefined' && _userInfo != null){
            _userInfo = JSON.parse(_userInfo);
            param.userToken = _userInfo.token;
            favParam.userToken = _userInfo.token;
          }

          let _setting = this.common.getCookie('setting');

          if(typeof(_setting) != 'undefined' && _setting != null){
            //alert('设置信息')
            //alert(JSON.stringify(_setting))
            _setting = JSON.parse(_setting);
            //this.sortType = _setting.sortRadio*1;
            //this.liveDatas.oddsType = _setting.oddsType*1;
            this.liveDatas.oddsForm = _setting.oddsFormRadio*1;
            this.liveParam['timeZone'] = _setting.tsz;
            this.liveDatas.tsz = _setting.tsz;
            param.timeZone = _setting.tsz;
          }

          let _oddsType = this.common.getCookie('oddsType');
          if(typeof(_oddsType) != 'undefined' && _oddsType != null){
            this.liveDatas.oddsType = _oddsType;
          }

          let _oddsTypeArr = this.common.getCookie('oddsTypeArr');
          if(typeof(_oddsTypeArr) != 'undefined' && _oddsTypeArr != null){
            this.liveDatas.oddsTypeArr = JSON.parse(_oddsTypeArr);
          }

          let _companyId = this.common.getCookie('companyId');
          if(typeof(_companyId) != 'undefined' && _companyId != null){
            this.companyId = _companyId;
          }

          // await getDataList(param).then((res) => {
          //   _version = res.data.version;
          //   this.version = _version;
            
          //   let _data = this.common.jsonParse(res.data);
          //   this.FootballListObj = _data;
          //   //this.leagueCollation();
            
          // }).catch((res) => {
          //   console.error(res)
          // })

          this.getListFollowLuck(param);

          await getFavoritesList(favParam).then((res) => {
            //console.log('关注列表',res.serverTimestamp)
            let _data = res.data;
            this.svrTimestamp = res.serverTimestamp;
            this.FootballList = _data;
            this.sortItemsByTimeKeys(_data);
            
            
          }).catch((res) => {
            console.error(res)
          })

          await this.setTodays();
          
          //this.getListLuckDiff(param);

          if(typeof(liveType) != 'undefined'){ //单比分请求
            return;
          }

          await getLeagueListFollow({ // 联赛-关注列表
            userToken: param.userToken,
          }).then((res) => {
            //console.log('关注列表', res)
            if(res.state == 200){
              let _data = this.common.jsonParse(res.data);
              let _myLeague = [];
              if(typeof(_data.league) != 'undefined'){
                _myLeague = _data.league;
              }
              this.myLeague = _myLeague;
              this.liveDatas.myLeague = this.myLeague;
            }
          }).catch((res) => {
            console.error(res)
          })

          await getLeagueListHot({ // 联赛-热门列表
            userToken: '',
          }).then((res) => {
            let _data = this.common.jsonParse(res.data);
            let _hotLeague = [];
            if(typeof(_data.league) != 'undefined'){
              _hotLeague = _data.league;
            }
            this.hotLeague = _hotLeague;
          }).catch((res) => {
            console.error(res)
          })

          await getListFollowIds({ // 比赛关注ID列表
            userToken: param.userToken,
          }).then((res) => {
            //console.log('关注ID列表', res)
            if(res.state == 200){
              let _data = this.common.jsonParse(res.data);
              let _follow = {};
              if(typeof(_data.follow) != 'undefined'){
                _follow = _data.follow;
              }
              this.follow = _follow;
              this.liveDatas.follow = this.follow;
            }
          }).catch((res) => {
            console.error(res)
          })

          if(typeof(window) != 'undefined'){
            this.getSocketFotballScore();
            this.getSocketFotballComLuck();

            await this.$socket.registerCallBack('FootballListReconnect', async ()=>{
              this.getMatchLuckCompany();
              await this.getLiveData({
                isLive: 1
              }, 'live');
              //await getSocket(this, _socketParam);
              this.getSocketFotballScore();
              this.getSocketFotballComLuck();
            });

            await this.$socket.registerCallBack('FootballListUpdate', this.listUpdate);
            await this.$socket.registerCallBack('FootballComListUpdate', this.oddsUpdate);
          }
      },

      // 开启socket比分更新请求
      async getSocketFotballScore(){
        let _socketParam = {
          type: 101,
          scoreVersion: Number(this.version)
        };
        await getSocket(this, _socketParam);
      },

      // 开启socket某公司指数更新请求
      async getSocketFotballComLuck(){
        let _socketParam = {
          type: 102,
          comId: this.companyId,
          scoreVersion: Number(this.version)
        };
        await getSocket(this, _socketParam);
      },

      //公司列表
      async getMatchLuckCompany(){
          //console.log('getMatchLuckCompany_param',param);
          await getMatchLuckCompany().then((res) => {
            //console.log('getMatchLuckCompany_res',res);
            let data=this.common.jsonParse(res.data);
            this.companys=data.companies||[];
          }).catch((res) => {
            console.error(res)
          })
      },

      // 公司指数列表
      async getListFollowLuck(obj){
        let param = Object.assign(obj, {
          comId: this.companyId
        });
        await getListFollowLuck(param).then((res) => {
          //console.log('getListFollowLuck_res',res);
          let data = this.common.jsonParse(res.data);
          this.companyData = data || {};
          this.oddsCollation();
          this.getListFollowLuckDiff(param);
        }).catch((res) => {
          console.error(res)
        })
      },
      
      // 公司指数差异
      async getListFollowLuckDiff(param){
        // let param = Object.assign(obj, {
        //   comId: this.companyId
        // });
        await getListFollowLuckDiff(param).then((res) => {
          //console.log('getListFollowLuckDiff',res);
          let _data = this.common.jsonParse(res.data);
          this.oddsFirstUpdate(_data)
        }).catch((res) => {
          console.error(res)
        })
      },
		},

		created(){
      if(typeof(window) != 'undefined'){
        this.getMatchLuckCompany();

        this.getLiveData({
          isLive: 1
        });

        getListAd({ //广告
          pageId: 2
        }).then((res) => {
          
          let _data = this.common.jsonParse(res.data);
          if(typeof(_data.webAds) != 'undefined'){
            this.ListAd = _data.webAds;
          }
        }).catch((res) => {
          console.error(res)
        })
      }
		},

    beforeDestroy() {
      if(typeof(window) != 'undefined'){
        document.removeEventListener('click', this.companyBodyClose);
      }
    },

    destroyed() {
      // 在组件销毁前关闭WebSocket连接
      this.$socket.unRegisterCallBack('FootballListUpdate');
      this.$socket.unRegisterCallBack('FootballComListUpdate');
      this.$socket.unRegisterCallBack('FootballListReconnect');
    },
	};

</script>
<style lang="less">
@import '~@/style/index/index.less';
</style>


// WEBPACK FOOTER //
// ./src/views/favorites/favorites.vue